export class TimeSlotDecorator {
    constructor(options = {}) {
        this.warnAboutUnassigned = !!options.warnAboutUnassigned;
    }

    decorateTimeSlotColor(timeSlot) {
        if (timeSlot.Employee) {
            return {
                borderColor: "#215490",
                backgroundColor: "#2764AB",
                color: "#FDFDFD"
            };
        } else if (this.warnAboutUnassigned) {
            // Use a "warning" color when not assigned.
            return {
                borderColor: "#EEA236",
                backgroundColor: "#F0AD4E",
                color: "#FFFFFF"
            };
        }
    }

    decorateTimeSlotInactive(timeSlot) {
        return neutral();
    }
}

function neutral() {
    return {
        borderColor: "#CCCCCC",
        backgroundColor: "#EFEFEF",
        color: "#111111"
    }
}
